import { Context } from 'react';
import { useController } from 'react-hook-form';
import { FieldContext } from './FieldContext';
import { FieldProps, FieldContext as TFieldContext } from './types';

export function Field({
  children,
  nonTouchedError,
  includeError = true,
  label,
  required,
  name,
}: FieldProps) {
  const FC = FieldContext as Context<TFieldContext>;
  const { field, fieldState } = useController({ name: name ?? '' });
  const { error, isTouched } = fieldState;
  const errorMessage = error?.message as unknown;

  const errorText =
    nonTouchedError || isTouched
      ? typeof errorMessage === 'object' && errorMessage !== null
        ? (errorMessage as Record<string, string>)['id']
        : (errorMessage as string | undefined)
      : undefined;

  return (
    <FC.Provider
      value={{
        name: field.name,
        value: field.value,
        onChange: field.onChange,
        onBlur: field.onBlur,
        ...(includeError
          ? {
              error: !!errorText,
              helperText: errorText,
            }
          : {}),
        label: required ? `${label} *` : label,
        'data-cy': `field-${name}`,
      }}
    >
      {children}
    </FC.Provider>
  );
}
